import React from 'react'
import { bindActionCreators } from 'redux'
import { push } from "connected-react-router"
import { connect } from 'react-redux'
import { Field, FieldType, SortableField, Table } from '../../table'
import swal from 'sweetalert'
import Api from '../../../../utils/api'
import { setActiveRole } from '../../../../modules/role'

class RoleMainPage extends React.Component {

  constructor (props) {
    super(props);

    this.state = {
    }

    this.tableStruct = [
      SortableField(FieldType.NONE, 'id', 'ID'),
      SortableField(FieldType.NONE, 'name', 'Роль'),
      SortableField(FieldType.BUTTON, 'edit', 'Редактировать'),
      SortableField(FieldType.BUTTON, 'delete', 'Удалить роль'),
    ];

  }

  componentDidMount() {
  }

  tableHandler = (action, value) => {
    let item = this.props.data.find(item => item.id === value);

    switch (action) {
      case 'delete':
        if(item) {
          swal({ title: "Вы уверены?", icon: "warning", buttons: ["Нет", "Да"] })
            .then((ok) => {
              if(ok) {
                Api.delete('/news-type/' + item.id)
                  .then(data => {
                    this.setState({ data: data.value || [] });
                    this.props.updateRole();
                  });
              }
            });
        }

        break;

      case 'edit':
        if (item) {
          this.props.setActiveRole(item);
          this.props.changePage('/admin/role/edit');
        }
        break;

      default:
        break;
    }
  }

  render() {
    let data = this.props.data || [];

    data = data.map(item => {
      return ({
        ...item,
        edit: true,
        delete: item.id !== 1
      })
    });

    return (
      <div className="row">
        <div>
          <button className="btn btn-sm btn-info" onClick={() => this.props.changePage('/admin/role/create')}>Создать роль</button>
        </div>
        <div style={{overflow: 'hidden'}}>
          <Table data={data} struct={this.tableStruct} onAction={this.tableHandler}/>
        </div>
      </div>
    )
  }

}

const mapStateToProps = ({ user, general, router }) => ({
  user,
  general,
  location: router.location
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setActiveRole,
      changePage: (page) => push(page)
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RoleMainPage)
